var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_8868)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_8868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H0V20H18V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_8868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7124 8.46429L17.4133 0H15.8254L10.0071 7.34942L5.35992 0H0L7.02738 11.1136L0 19.9897H1.58799L7.73237 12.2285L12.6401 19.9897H18L10.7121 8.46429H10.7124ZM8.53747 11.2115L7.82546 10.1049L2.16017 1.29901H4.59922L9.17118 8.40562L9.8832 9.51229L15.8262 18.7498H13.3871L8.53747 11.212V11.2115Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_8868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.f4b0a12f8d1f5ffc5f19dd46a04fadaa.svg";
export { ForwardRef as ReactComponent };